module.exports = __webpack_public_path__ + "static/customer-coffee-034f10c3d408fe4a05be2d437419b662.jpg";